import React from "react";
import { Spin } from "antd";

const Loader = ({ loading, text = "Loading..." }) => {
  return loading ? (
    <div className="fixed top-0 left-0 right-0  bottom-0 bg-gray-100 bg-opacity-50 z-50 flex justify-center items-center">
      <Spin tip={text} size="large" />
    </div>
  ) : null;
};

export default Loader;
